import { AICoachGoalDecisionType } from 'enums/AICoach';

import Api, { FetchMethodType } from './Api';

export interface GoalOptimizerAction {
  actionText: string;
  actionType: string;
  id: number;
  isDecision: boolean;
  isEducation: boolean;
  isUserChoice: boolean;
  goals?: (AICoachGoalDecisionType | string)[];
}

export interface GoalOptimizerRecommendation {
  actions: GoalOptimizerAction[];
  explanation: string;
}

export interface GoalOptimizerRecommendationResponse {
  recommendation: GoalOptimizerRecommendation;
  recommendedPrimaryGoal: AICoachGoalDecisionType;
  recommendedSecondaryGoal: AICoachGoalDecisionType;
}

export interface GoalOptimizerExplainResponse {
  explanation: string;
  actionText: string;
  suggestedTopics: GoalOptimizerAction[];
}

export interface GoalOptimizerExplainRequest {
  applicationId: string;
  actionText: string;
  recommendedGoalType: AICoachGoalDecisionType;
  recommendedGoalTypeSecondary?: AICoachGoalDecisionType;
  topicsCovered: string[];
}

export interface GoalOptimizerParaphraseRequest {
  applicationId: string;
  text: string;
}

export interface GoalOptimizerParaphraseResponse {
  paraphrasedText: string;
}

export default class GoalOptimizerApi extends Api {
  recommend(applicationId: string): Promise<GoalOptimizerRecommendationResponse> {
    return this.fetch<GoalOptimizerRecommendationResponse>('/goalOptimizer/recommend', {
      method: FetchMethodType.POST,
      body: { applicationId },
    });
  }

  explain(requestData: GoalOptimizerExplainRequest): Promise<GoalOptimizerExplainResponse> {
    return this.fetch<GoalOptimizerExplainResponse>('/goalOptimizer/explain', {
      method: FetchMethodType.POST,
      body: requestData,
    });
  }

  paraphrase(requestData: GoalOptimizerParaphraseRequest): Promise<GoalOptimizerParaphraseResponse> {
    return this.fetch<GoalOptimizerParaphraseResponse>('/goalOptimizer/paraphrase', {
      method: FetchMethodType.POST,
      body: requestData,
    });
  }
}
